import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import Alert from '../Alert/index.js';
import Collapse from '../Collapse/index.js';
function AlertAutoClose(_ref) {
  let {
    bsStyle,
    children,
    className,
    onHide = () => {},
    show = false,
    sticky = true,
    timeout = 4000,
    ...rest
  } = _ref;
  const [showAlert, setShowAlert] = useState(false);
  const handleDismissAlert = () => {
    setShowAlert(false);
  };
  const handleOnHide = () => {
    onHide();
  };
  useEffect(() => {
    if (show) {
      setShowAlert(true);
      setTimeout(handleDismissAlert, timeout);
    }
    return () => {
      clearTimeout(handleDismissAlert);
    };
  }, [show, timeout]);
  return /*#__PURE__*/React.createElement(Collapse, Object.assign({
    className: clsx(className, {
      'sticky-alert container-fluid': sticky
    }),
    in: showAlert,
    timeout: 500,
    onExited: handleOnHide
  }, rest), /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Alert, {
    bsStyle: bsStyle,
    onDismiss: handleDismissAlert
  }, void 0, children)));
}
export default AlertAutoClose;